// @ts-nocheck
export function jumpTo(url) {
    if (window.$wujie?.props.jumpTo) {
        window.$wujie.props.jumpTo(url);
    }
    else {
        window.location.href = url;
    }
}
